import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    SeeProducts, SeeProductsByCode, SeeProductsByName,
    SeeProductsByPresentation, SeeProductsPresentations,
    getReportByType, getUtilityReport
} from '../../../actions/productActions'
import ProductListView from '../../../containers/Inventory/Products/ProducList/ProductList'

const ProductList = () => {
    const { productsList, presentations, reportByType, utilityReport } = useSelector(state => state.productsList)
    const dispatch = useDispatch()
    const [presentation, setPresentation] = useState(null)
    const [reportType, setReportType] = useState("mostSold");
    
    const [reportInitialDate, setReportInitialDate] = useState(new Date());
    const [reportEndDate, setReportEndDate] = useState(new Date());
    useEffect(() => {
        dispatch(getReportByType(reportType, reportInitialDate, reportEndDate))
        dispatch(getUtilityReport(reportInitialDate, reportEndDate))
    }, [reportInitialDate, reportType, reportEndDate]);

    useEffect(() => {
        if (presentation) {
            dispatch(SeeProductsByPresentation(presentation))
        } else {
            dispatch(SeeProducts())
        }

        return () => {

        }
    }, [presentation])

    useEffect(() => {

        dispatch(SeeProductsPresentations())
        return () => {

        }
    }, [])
    const searchAction = (value) => {
        dispatch(SeeProductsByName(value))
    }

    return (
        <ProductListView
            products={productsList}
            searchAction={searchAction}
            presentations={presentations}
            presentation={presentation}
            reportType={reportType}
            setReportType={setReportType}
            reportInitialDate={reportInitialDate}
            setReportInitialDate={setReportInitialDate}
            reportEndDate={reportEndDate}
            setReportEndDate={setReportEndDate}
            utilityReport={utilityReport}
            reportByType={reportByType}
        />
    )
}

export default ProductList